<template>
  <div v-bind="$attrs" class="bg-white p-1 rounded-md shadow-md text-left">
    <div class="rounded overflow-hidden" :class="theme">

      <header v-if="$slots.title || title" class="px-5 py-4">
        <slot name="title">
          <h3 class="text-xl font-semibold">{{ title }}</h3>
        </slot>
      </header>

      <figure class="bg-gray-100">
        <component
          class="block"
          :class="background"
          :href="link"
          :is="link ? 'Link' : 'div'"
        >
          <img
            v-if="image"
            class="lazy block w-full h-auto mx-auto max-w-sm"
            :data-src="image.url"
            :height="image.height"
            :width="image.width"
            :alt="image.metadata?.alt ?? alt"
          >
        </component>

        <figcaption v-if="$slots.caption || caption" class="px-5 p-4 text-gray-900">
          <slot name="caption">
            <strong class="text-lg font-semibold">{{ caption }}</strong>
          </slot>
        </figcaption>
      </figure>

    </div>
    <footer class="flex flex-wrap items-center justify-between p-5 mt-1">

      <slot name="footer" />

    </footer>
  </div>
</template>

<script>
import Link from 'Web/Shared/Link.vue';
import { computed } from 'vue';

export default {
  inheritAttrs: false,
  components: {
    Link,
  },
  props: {
    alt: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    image: {
      type: Object,
      default: null,
    },
    link: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    theme: {
      type: String,
      default: 'default',
    },
    background: {
      type: String,
      default: 'bg-gray-100',
    },
  },
  setup(props) {
    const theme = computed(() => ({
      'default': 'bg-gray-100',
      'blue': 'bg-gradient-to-r from-blue-500 to-blue-accent text-white',
    }[props.theme]));

    return {
      theme,
    }
  }
}
</script>
